"use strict";

var _require = require('lodash'),
  includes = _require.includes;
var _require2 = require('./errors'),
  UnknownModuleError = _require2.UnknownModuleError;
module.exports = function (moduleList) {
  return {
    validate: function validate(moduleName) {
      if (!includes(moduleList, moduleName)) {
        throw new UnknownModuleError(moduleName);
      }
    }
  };
};
//# sourceMappingURL=moduleValidtor.js.map